<script>
  import { onMount } from 'svelte';

  export let width = '460px';
  export let height = 'auto';
  export let maxHeight = '90vh';
  export let onClose = () => {};

  const DEFAULT_WIDTH = 460;
  const DEFAULT_HEIGHT = 520;
  const TOP_GAP = 16;

  let x = 0;
  let y = 0;

  let dragging = false;
  let startX, startY;

  function parseDimension(value, fallback) {
    const parsed = Number.parseFloat(String(value || '').replace('px', ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function centerWindow() {
    const targetWidth = parseDimension(width, DEFAULT_WIDTH);
    const targetHeight = parseDimension(height, DEFAULT_HEIGHT);

    x = Math.max(0, (window.innerWidth - targetWidth) / 2);
    y = Math.max(TOP_GAP, Math.round((window.innerHeight - targetHeight) * 0.18));
  }

  onMount(() => {
    centerWindow();
    window.addEventListener('resize', centerWindow);

    return () => {
      window.removeEventListener('resize', centerWindow);
    };
  });

  function onMouseDown(e) {
    dragging = true;
    startX = e.clientX - x;
    startY = e.clientY - y;

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  }

  function onMouseMove(e) {
    if (!dragging) return;
    x = e.clientX - startX;
    y = e.clientY - startY;
  }

  function onMouseUp() {
    dragging = false;
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  }
</script>

<div
  class="absolute flex max-h-[90vh] flex-col overflow-hidden bg-white rounded-xl shadow-2xl select-none"
  style="
    width:{width};
    height:{height};
    max-height:{maxHeight};
    left:{x}px;
    top:{y}px;
  ">
  <!-- HEADER (drag handle) -->
  <div
    class="h-12 px-4 flex items-center justify-between
           cursor-move
           border-b border-gray-300
           bg-gray-50 rounded-t-xl"
    on:mousedown={onMouseDown}>
    <slot name="title" />
    <button class="text-gray-500 hover:text-gray-800" on:click={onClose}>✕</button>
  </div>

  <!-- BODY -->
  <div class="relative min-h-0 flex-1 overflow-auto">
    <slot />
  </div>
</div>
